import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function ProofHero() {
  return <section className="relative pt-24 pb-32 px-4 overflow-hidden" data-id="element-658">
      <div className="absolute inset-0 z-0" data-id="element-659">
        <img src="https://cdn.magicpatterns.com/uploads/eWobd4pCS33AwfX1B22oMP/whatparents.jpg" alt="What Parents Are Saying" className="w-full h-full object-cover object-top" data-id="element-660" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0f1f3d]/90 via-[#0f1f3d]/85 to-[#0f1f3d]/90" data-id="element-661"></div>
      </div>

      <div className="max-w-6xl mx-auto text-center relative z-10" data-id="element-662">
        <motion.div initial="hidden" animate="visible" variants={fadeIn} className="space-y-6" data-id="element-663">
          <div className="flex justify-center gap-1 mb-4" data-id="element-664">
            {[1, 2, 3, 4, 5].map((_, i) => <Star key={i} className="w-6 h-6 text-yellow-400 fill-current drop-shadow-lg" data-id="element-665" />)}
          </div>
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-black text-white leading-tight tracking-tight drop-shadow-2xl" data-id="element-666">
            What Parents Are Saying
          </h1>
          <div className="w-24 h-1 bg-[#a3d977] mx-auto rounded-full mb-6" data-id="element-667"></div>
          <p className="text-lg sm:text-xl text-white/95 max-w-3xl mx-auto leading-relaxed drop-shadow-lg" data-id="element-668">
            Real stories from real families who've experienced the
            transformative power of NWBBA. These aren't just
            testimonials—they're proof that martial arts changes lives.
          </p>
        </motion.div>
      </div>
    </section>;
}